import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import FIRMWARE_CURRENT_VERSION_MOCK from "../../ota-update/mocks/mocked-firmware-current-version-response.json";
import { CurrentFirmwareVersion } from "@src/types/ota-update";
import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
const USE_MOCK = false;
const mock_data = FIRMWARE_CURRENT_VERSION_MOCK as CurrentFirmwareVersion;
export const getCurrentFirmwareVersion = async (
  namespace: string,
  sourceId: string,
  signal?: AbortSignal,
) => {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 3000));
    return {
      data: mock_data,
    };
  }
  const url = otaUpdatesUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<CurrentFirmwareVersion>(
      `${url}/api/v1/ns/${namespace}/source/${sourceId}/current-firmware-version`,
      { headers, signal },
    );

    return response;
  } catch (err) {
    if (signal?.aborted) return;
    else if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch current firmware version.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching current firmware version.",
      );
    }
  }
};
